module.exports = __webpack_public_path__ + "img/NorwegianCard2.ad4c56b6.jpg";